import { AppButton } from "@/shared/Components";
import { TrashIcon } from "@/shared/icons";
import type { PropsWithChildren, FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  onTrashClick?: () => void;
};

export const Edit: FC<PropsWithChildren<Props>> = ({ onTrashClick, children }) => {
  return (
    <div className={styles.edit}>
      <div className={styles.fields}>{children}</div>
      <div className={styles.delete}>
        <AppButton onClick={onTrashClick} className={styles["delete-button"]}>
          <TrashIcon />
        </AppButton>
      </div>
    </div>
  );
};
